<!--
 * @Author: zhangmh31513
 * @Date: 2021-09-13 20:10:13
 * @LastEditTime: 2021-10-21 16:18:49
 * @LastEditors: zhangmh31513
 * @Description:
 * @FilePath: \openplat-web\src\gtn\views\frontViews\developerConference\components\countDown.vue
 * 有问题请第一时间来联系我
-->
<template>
  <div class="countdowm">
    <div class="time-item">
      <div class="top">DAY</div>
      <div class="dy-time">{{ days }}</div>
    </div>
    <span></span>
    <div class="time-item">
      <div class="top">HOUR</div>
      <div class="dy-time">{{ hours }}</div>
    </div>
    <span></span>
    <div class="time-item">
      <div class="top">MINUTE</div>
      <div class="dy-time">{{ mins }}</div>
    </div>
    <span></span>
    <div class="time-item">
      <div class="top">SECOND</div>
      <div class="dy-time">{{ seconds }}</div>
    </div>
  </div>
</template>
<script>
/* eslint-disable object-curly-newline */

export default {
  name: "CountDown",
  data: () => ({
    days: "0",
    hours: "00",
    mins: "00",
    seconds: "00",
    timer: null,
    curTime: 0
  }),
  props: {
    time: {
      type: [Number, String],
      default: 0
    },
    refreshCounter: {
      type: [Number, String],
      default: 0
    },
    end: {
      type: [Number, String],
      default: 0
    },
    isMiniSecond: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    duration() {
      if (this.end) {
        let end = String(this.end).length >= 13 ? +this.end : +this.end * 1000;
        end -= Date.now();
        return end;
      }
      const time = this.isMiniSecond
        ? Math.round(+this.time / 1000)
        : Math.round(+this.time);
      return time;
    }
  },
  mounted() {
    this.countDown();
  },
  watch: {
    duration() {
      this.countDown();
    },
    refreshCounter() {
      this.countDown();
    }
  },
  methods: {
    durationFormatter(time) {
      if (!time) return { ss: "00" };
      let t = time;

      let ss = t % 60;
      if (ss < 10) ss = "0" + ss;
      t = (t - ss) / 60;
      if (t < 1) return { ss };

      let mm = t % 60;
      if (mm < 10) mm = "0" + mm;
      t = (t - mm) / 60;
      if (t < 1) return { mm, ss };

      let hh = t % 24;
      if (hh < 10) hh = "0" + hh;
      t = (t - hh) / 24;
      if (t < 1) return { hh, mm, ss };

      let dd = t;
      if (dd < 10) dd = "0" + dd;
      return { dd, hh, mm, ss };
    },
    countDown() {
      // eslint-disable-next-line no-unused-expressions
      this.curTime = Date.now();
      this.getTime(this.duration);
    },
    getTime(time) {
      // eslint-disable-next-line no-unused-expressions
      this.timer && clearTimeout(this.timer);
      if (time < 0) {
        return;
      }
      // eslint-disable-next-line object-curly-newline
      const { dd, hh, mm, ss } = this.durationFormatter(time);
      this.days = dd || "00";
      // this.hours = `00${hh || ''}`.slice(-2);
      // this.mins = `00${mm || ''}`.slice(-2);
      // this.seconds = `00${ss || ''}`.slice(-2);
      this.hours = hh || "00";
      this.mins = mm || "00";
      this.seconds = ss || "00";
      this.timer = setTimeout(() => {
        const now = Date.now();
        const diffTime = Math.floor((now - this.curTime) / 1000);
        const step = diffTime > 1 ? diffTime : 1; // 页面退到后台的时候不会计时，对比时间差，大于1s的重置倒计时
        this.curTime = now;
        this.getTime(time - step);
      }, 1000);
    }
  }
};
</script>
<style lang="scss" scoped>
.countdowm {
  font-weight: 700;
  justify-content: space-between;
  span {
    display: inline-block;
    margin-top: 50px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: #3026ff;
  }
  .time-item {
    .top {
      font-size: 16px;
    }
    .dy-time {
      font-size: 64px;
      font-family: "led";
    }
  }
}
@media (max-width: 1366px) {
  .countdowm {
    .time-item {
      .top {
        font-size: 12px;
      }
      .dy-time {
        font-size: 34px;
      }
    }

    span {
      margin-top: 35px;
      width: 10px;
      height: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/developerConference/components/countDown.vue